import React, { useState, useRef, useEffect } from "react";
import {
    Container,
    Grid,
    TextField,
    Box,
    Button,
    Typography,
    IconButton,
    InputAdornment,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PasswordService from "../service/PasswordService";
import CONSTANTS from "../../../constants/constants";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { SnackbarAlert } from "../../common/SnackbarAlert";
import SimpleReactValidator from "simple-react-validator";
import { ROUTES } from "../../../constants/routes";

const VerifyPassword = (props: any) => {
    const { showSnackbar, handleLoader } = props;
    {
    /* Language translate function*/
    }
    const [t, i18n] = useTranslation();
    {
    /* Language translate function*/
    }

    const navigate = useNavigate();

    const [password, setPassword] = useState("");
    const [passwordType, setPasswordType] = useState("password");
    const [error, setError] = useState("");
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [successAlert, setSuccessAlert] = useState(false);

    // validation
    const [, forceUpdate] = useState(0);

    const validator = useRef(
        new SimpleReactValidator({
            autoForceUpdate: { forceUpdate },
            className: "text-danger",
            messages: {
                regex: t("verify_password.please_enter_valid_password"),
                required: t("required.this_field_cannot_be_empty"),
            },
        })
    );

    useEffect(() => {
        forceUpdate(1);
    });
    //validation

    const handleOnBlur = (e: any) => {
        const { name } = e.target;

        validator.current.showMessageFor(name);
    };

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        name === "password" ? setPassword(value) : null;

        validator.current.hideMessageFor(name);
    };

    const handleSubmit = () => {
        if (validator.current.allValid()) {
            handleLoader(true);
            const payload = { password };
            const isHitDummyURL = false;
            new PasswordService(payload, isHitDummyURL)
                .verify()
                .then((res) => {
                    handleLoader(false);
                    showSnackbar(res, true);
                    navigate(ROUTES.UPDATE_PASSWORD);
                })
                .catch((err) => {
                    handleLoader(false);
                    showSnackbar(err?.message, false);
                });
        } else {
            validator.current.showMessages();
        }
    };

    const handleCloseSnackBar = () => {
        setOpenSnackBar(false);
    };

    const handleClickShowPassword = () => {
        passwordType == "password"
            ? setPasswordType("text")
            : setPasswordType("password");
    };

    const handleMouseDownPassword = (e: any) => {
        setPasswordType("text");
        e.preventDefault();
    };

    return (
        <>
            <div className="main">
                {/* VerifiedOTP page starts here */}
                <Container>
                    <Grid container sx={{ py: 10 }}>
                        {/* offset grid with column*/}
                        <Grid item xs={12} xl={4} lg={4} md={2} sm={12}></Grid>
                        {/* main grid column! */}
                       
                        <Grid item xs={12} xl={4} lg={4} md={8} sm={12}>
                            <Box sx={{ textAlign: "center", my: "1rem" }}>
                                <Typography variant="h6">
                                    {t("verify_password.verify_password")}
                                </Typography>
                                <Typography>
                                    {t("verify_password.current_password_verify")}
                                </Typography>
                            </Box>
                            <Grid sx={{ mb: 2 }}>
                                <TextField
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    // onTouchStart={handleMouseDownPassword}
                                                    // onTouchEnd={handleClickShowPassword}
                                                    onClick={handleClickShowPassword}
                                                    // onMouseDown={handleMouseDownPassword}
                                                >
                                                    {passwordType == "password" ? (
                                                        <VisibilityIcon />
                                                    ) : (
                                                        <VisibilityOffIcon />
                                                    )}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    type={passwordType}
                                    fullWidth
                                    value={password}
                                    name="password"
                                    label={t("verify_password.password")}
                                    variant="outlined"
                                    onChange={(e) => handleChange(e)}
                                    error={error ? true : false}
                                    helperText={error}
                                    onBlur={(e) => handleOnBlur(e)}
                                />
                                {validator.current.message("password", password, [
                                    "required",
                                    { regex: CONSTANTS.PASSWORD_REGEX },
                                ])}
                            </Grid>
                        
                            <Grid sx={{ mb: 2 }}>
                                <Button fullWidth onClick={handleSubmit}>
                                    {t("verify_password.verify")}
                                </Button>
                            </Grid>
                        </Grid>
                        {/* offset grid with column*/}
                        <Grid item xs={12} xl={4} lg={4} md={2} sm={12}></Grid>
                    </Grid>
                </Container>
                
                {/* VerifiedOTP page ends here */}
            </div>
        </>
    );
};

export default VerifyPassword;
